module.exports = __webpack_public_path__ + "static/img/Cooper-Hynes.19735aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cooper-Hynes.jpg
// module id = 7/LX
// module chunks = 0